<template>
    <div>
        <b-container>
          <b-button :to="{ name: 'Home'}" variant="primary" class="mb-2">Voltar</b-button>
          <b-card border-variant="primary" header="Emergência - Resumo" header-bg-variant="primary" header-text-variant="white">
            <b-table-simple class='table table-sm'>
              <b-thead>
                <b-tr >
                  <b-th>
                    Especialidade
                  </b-th>
                  <b-th>
                    Status
                  </b-th>
                  <b-th>
                    Quant.
                  </b-th>
                </b-tr>
               </b-thead>
                <b-tbody>
                    <b-tr v-for="(itemlistatot, index) in listareforcototais" :key="index" :style="'color:#'+itemlistatot.cz46_cor+';margin-top:1px;margin-bottom:1px;font-size:0.8em'">
                      <b-td >
                         {{itemlistatot.cz41_descr}}
                      </b-td>
                      <b-td >
                         {{itemlistatot.cz46_descr}}
                      </b-td>
                      <b-td >
                         {{itemlistatot.qt}}
                      </b-td>
                    </b-tr>
                 </b-tbody>
            </b-table-simple>
          </b-card>
          <b-card border-variant="primary" header="Emergência - Lista" header-bg-variant="primary" header-text-variant="white">
              <b-table-simple class='table table-sm'>
              <b-thead>
                <b-tr>
                  <b-th>
                    Especialidade - Status
                  </b-th>
                  <b-th>
                    Hora
                  </b-th>
                  <b-th>
                    Paciente - Causa
                  </b-th>
                  <b-th>
                    #
                  </b-th>
                </b-tr>
               </b-thead>
                <b-tbody>
                    <b-tr v-for="(itemlista, index) in listareforco" :key="index" :style="'color:#'+itemlista.cz46_cor+';font-size:0.8em'">
                      <b-td >
                        {{itemlista.cz41_descr}} -{{itemlista.cz46_descr}}
                      </b-td>
                      <b-td >
                        {{itemlista.cz06_hrat}}
                      </b-td>
                      <b-td >
                        {{itemlista.cz04_nome}} -
                        {{itemlista.cz06_obs}} -
                      </b-td>
                      <b-td >
                        <b-button :to="{ name: 'Ficha', params: {id: itemlista.cz06_nrop}}" variant="primary" class="mb-2">Ficha</b-button>
                      </b-td>
                    </b-tr>
                 </b-tbody>
            </b-table-simple>
          </b-card>
        </b-container>
    </div>
</template>

<script>
import Listareforco from '../services/ListaReforcoService'
import ListaReforcototais from '../services/ListaReforcototaisService'

export default {
  name: 'listareforco',
  data () {
    return {
      listareforco: [],
      listareforcototais: []
    }
  },
  created () {
    this.pesquisa()
    this.pesquisatotais()
    this.timer()
  },
  methods: {
    timer () {
      var self = this
      var tempo = 60000 * 5
      // var tempo = 3000
      setInterval(() => {
        self.pesquisa()
        self.pesquisatotais()
        console.log('chamou')
      }, tempo)
    },
    pesquisa () {
      let pesquisa = {}
      const obj = JSON.parse(localStorage.usuarioMC)

      if (obj.empresa !== undefined) {
        pesquisa.empresa = JSON.stringify(obj.empresa)
      }
      if (obj.usuario.cz08_crem !== undefined) {
        pesquisa.crm = obj.usuario.cz08_crem
      }
      pesquisa.pendentes = 'true'
      pesquisa.usuario = obj.usuario
      Listareforco.index(pesquisa).then((result) => {
        this.listareforco = result
      }).catch((err) => {
        console.log(err)
      })
    },
    pesquisatotais () {
      let pesquisa = {}
      const obj = JSON.parse(localStorage.usuarioMC)
      if (obj.empresa !== undefined) {
        pesquisa.empresa = JSON.stringify(obj.empresa)
      }
      if (obj.usuario.cz08_crem !== undefined) {
        pesquisa.crm = obj.usuario.cz08_crem
      }
      pesquisa.pendentes = 'true'
      pesquisa.usuario = obj.usuario
      ListaReforcototais.index(pesquisa).then((result) => {
        this.listareforcototais = result
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/Listareforco.vue